<template>
  <div class="base-tab" v-if="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseTab',
  props: {
    /**
     * 頁籤名稱
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * 頁籤標籤
     */
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    /**
     * 是否為當前頁籤
     * @returns {Boolean}
     */
    isActive() {
      return this.$parent.value === this.name;
    },
  },
};
</script>
